import { WINDOW_EVENTS } from '../../constants/events';

export const removeErrorMessage = () => ({
  type: WINDOW_EVENTS.REMOVE_ERROR_MESSAGE,
  payload: {applyErrorMessage: null}
});

export const updateWindowData = (payload) => ({
  type: WINDOW_EVENTS.UPDATE_DATA,
  payload
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/windowActions/index.js